import React, { useContext } from "react";
import { CartContext } from "../context/cart-context";
import PayPalButton from "./PayPalButton";

const CartTotals = () => {
  const cart = useContext(CartContext);
  return (
    <div className="container">
      <div className="row">
        <div className="col-10 mt-2 ml-sm-5 ml-md-auto col-sm-8 text-capitalize text-right">
          <button
            className="btn btn-outline-danger btn-large text-uppercase mb-3 px-5"
            type="button"
            onClick={() => cart.clearCart()}
          >
            Clear cart
          </button>
          <h5>
            <span className="text-title">
              Subtotal:<strong>$ {cart.cost.subTotal}</strong>
            </span>
          </h5>
          <h5>
            <span className="text-title">
              Tax:<strong>$ {cart.cost.tax}</strong>
            </span>
          </h5>
          <h5>
            <span className="text-title">
              Total:<strong>$ {cart.cost.total}</strong>
            </span>
          </h5>
          <PayPalButton
            total={cart.cost.total}
            cart={cart.cart}
            clearCart={cart.clearCart}
          ></PayPalButton>
        </div>
      </div>
    </div>
  );
};

export default CartTotals;
